import { useEffect, useState } from "react";

import NeutralDocumentUploadComponent from "../../../Components/DocumentUploader";
import {
  FormInput,
  FormSelect,
  FormTextArea,
} from "../../../Components/Forms/InputTemplate";
export const Content1 = ({
  objIndex,
  kraIndex,
  defaultValues,
  formMethods,
  items,
}) => {
  const [documents, setDocuments] = useState([]);
  const handleDocumentsChange = (newDocuments) => {
    setDocuments(newDocuments);
    formMethods.setValue(
      `KRAs_${objIndex}_${kraIndex}_artifacts`,
      newDocuments
    );
  };
  const { reset, setValue } = formMethods;
  useEffect(() => {
    if (
      defaultValues?.kraActualScore !== undefined &&
      defaultValues?.kraActualScore !== null
    ) {
      reset({
        [`KRAs_${objIndex}_${kraIndex}_actualScore`]:
          defaultValues?.kraActualScore,
      });
    }
  }, [defaultValues?.kraActualScore, reset, objIndex, kraIndex]);
  const hasDocuments = documents?.length > 0;
  const renderActualScoreInput = () => {
    const measurementType = items?.measurementType;
    const currencyType = items?.currencyType || "";

    switch (measurementType) {
      case 1: // Number
        return (
          <FormInput
            title={"KRA Actual Score (Number)"}
            camelCase={`KRAs_${objIndex}_${kraIndex}_actualScore`}
            placeholder={"Enter actual score"}
            className="mb-4"
            type="number"
            isOptional={true}
            onChange={(e) => {
              const value = e.target.value;
              setValue(
                `KRAs_${objIndex}_${kraIndex}_actualScore`,
                value ? Number(value) : ""
              );
            }}
          />
        );

      case 2: // Currency
        return (
          <div className="mb-4">
            <FormInput
              title={`KRA Actual Score (Currency - ${currencyType})`}
              camelCase={`KRAs_${objIndex}_${kraIndex}_actualScore`}
              placeholder={"Enter actual score"}
              className="mb-4"
              type="number"
              isOptional={true}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  `KRAs_${objIndex}_${kraIndex}_actualScore`,
                  value ? Number(value) : ""
                );
              }}
            />
          </div>
        );

      case 3: // Percentage
        return (
          <FormInput
            title={"KRA Actual Score (Percentage)"}
            camelCase={`KRAs_${objIndex}_${kraIndex}_actualScore`}
            placeholder={"Enter actual score"}
            className="mb-4"
            type="number"
            isOptional={true}
            onChange={(e) => {
              const value = e.target.value;
              setValue(
                `KRAs_${objIndex}_${kraIndex}_actualScore`,
                value ? Number(value) : ""
              );
            }}
          />
        );

      case 4: {
        // Rating Scale
        // Generate rating options from items.ratingScales

        return (
          <div className="mb-4">
            <FormSelect
              title={"KRA Actual Score (Rating Scale)"}
              camelCase={`KRAs_${objIndex}_${kraIndex}_actualScore`}
              placeholder={"Select rating"}
              className="mb-4"
              array={items?.ratingScales?.map((opt) => (
                <option key={opt.id} value={opt.scaleNumber}>
                  {`${opt.scaleTitle} (${opt.scaleNumber})`}
                </option>
              ))}
              isOptional={true}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  `KRAs_${objIndex}_${kraIndex}_actualScore`,
                  value ? Number(value) : ""
                );
              }}
            />
          </div>
        );
      }

      case 5: // Yes/No
        return (
          <FormSelect
            title={"KRA Actual Score (Yes/No)"}
            camelCase={`KRAs_${objIndex}_${kraIndex}_actualScore`}
            placeholder={"Select Yes or No"}
            className="mb-4"
            array={[
              { value: 1, label: "Yes" },
              { value: 0, label: "No" },
            ]?.map((opt) => (
              <option key={opt.id} value={opt.value}>
                {opt.label}
              </option>
            ))}
            isOptional={true}
            onChange={(e) => {
              const value = e.target.value;
              setValue(
                `KRAs_${objIndex}_${kraIndex}_actualScore`,
                value ? Number(value) : ""
              );
            }}
          />
        );

      default:
        return (
          <FormInput
            title={"KRA Actual Score"}
            camelCase={`KRAs_${objIndex}_${kraIndex}_actualScore`}
            placeholder={"Enter actual score"}
            className="mb-4"
            type="number"
            isOptional={true}
            onChange={(e) => {
              const value = e.target.value;
              setValue(
                `KRAs_${objIndex}_${kraIndex}_actualScore`,
                value ? Number(value) : ""
              );
            }}
          />
        );
    }
  };

  return (
    <div className="px-5">
      {renderActualScoreInput()}
      <FormTextArea
        className="h-[100px]"
        title={"KRA Comments"}
        camelCase={`KRAs_${objIndex}_${kraIndex}_comments`}
        placeholder="Enter comments for this KRA"
        type="text"
        textAreaClassName=""
        defaultValue={defaultValues?.comment}
      />
      <NeutralDocumentUploadComponent
        defaultDocuments={defaultValues?.documents}
        name={"Supporting Document"}
        title={"Upload Supporting Documents for KRA (500kb max)"}
        hasDocuments={hasDocuments}
        onDocumentsChange={handleDocumentsChange}
        id={`supportingDocuments_${objIndex}_${kraIndex}`}
        disabled={items?.isAutoGenerated}
      />
    </div>
  );
};

export const MetaData = ({ data, referenceId }) => {
  return (
    <div className="px-5 py-4">
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(32.3%, 1fr))",
          gap: "16px",
        }}
      >
        <div className="mb-3">
          <p className="text-[#305F32] font-[600] text-sm mb-1">Name:</p>
          <h4 className="text-[#4B664C] font-[500] text-base">
            {data?.fullName || "Not available"}
          </h4>
        </div>
        <div className="mb-3">
          <p className="text-[#305F32] font-[600] text-sm mb-1">Email:</p>
          <h4 className="text-[#4B664C] font-[500] text-base">
            {data?.email || "Not available"}
          </h4>
        </div>
        <div className="mb-3">
          <p className="text-[#305F32] font-[600] text-sm mb-1">Department:</p>
          <h4 className="text-[#4B664C] font-[500] text-base">
            {data?.department || "Not available"}
          </h4>
        </div>
        <div className="mb-3">
          <p className="text-[#305F32] font-[600] text-sm mb-1">Location:</p>
          <h4 className="text-[#4B664C] font-[500] text-base">
            {data?.location || "Not available"}
          </h4>
        </div>
        <div className="mb-3">
          <p className="text-[#305F32] font-[600] text-sm mb-1">Job Role:</p>
          <h4 className="text-[#4B664C] font-[500] text-base">
            {data?.jobRole || "Not available"}
          </h4>
        </div>
        <div className="mb-3">
          <p className="text-[#305F32] font-[600] text-sm mb-1">Unit:</p>
          <h4 className="text-[#4B664C] font-[500] text-base">
            {data?.unit || "Not available"}
          </h4>
        </div>
        <div className="mb-3">
          <p className="text-[#305F32] font-[600] text-sm mb-1">Staff Code:</p>
          <h4 className="text-[#4B664C] font-[500] text-base">
            {data?.staffCode || "Not available"}
          </h4>
        </div>
        {referenceId && (
          <div className="mb-3">
            <p className="text-[#305F32] font-[600] text-sm mb-1">
              Reference Id:
            </p>
            <h4 className="text-[#4B664C] font-[500] text-base">
              {referenceId || "Not available"}
            </h4>
          </div>
        )}
        <div className="mb-3">
          <p className="text-[#305F32] font-[600] text-sm mb-1">Designation:</p>
          <h4 className="text-[#4B664C] font-[500] text-base">
            {data?.jobGrade || "Not available"}
          </h4>
        </div>
        <div className="mb-3">
          <p className="text-[#305F32] font-[600] text-sm mb-1">
            Employment Status:
          </p>
          <h4 className="text-[#4B664C] font-[500] text-base">
            {data?.employementStatus || "Not available"}
          </h4>
        </div>
      </div>
    </div>
  );
};
